import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

// Components
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import HeroSectionEditor from './components/HeroSectionEditor';
import ContactUsSectionEditor from './components/ContactUsSectionEditor';
import AboutUsSectionEditor from './components/AboutUsSectionEditor';
import ServicesSectionEditor from './components/ServicesSectionEditor';
import ProductManagement from './components/ProductManagement';
import HeaderEditor from './components/HeaderEditor';
import DealershipLogosEditor from './components/DealershipLogosEditor';
import AllProductsView from './components/AllProductsView'; // Import the new component
import UpdatePasswordPage from './pages/UpdatePasswordPage';
import ManageUsersPage from './pages/ManageUsersPage'; // New page for user management

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

// Styles
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <ToastContainer 
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="app">
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <Dashboard />
                    </div>
                  </div>
                </ProtectedRoute>
              } />
              
              <Route path="/dashboard/hero-section" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <HeroSectionEditor />
                    </div>
                  </div>
                </ProtectedRoute>
              } />


              <Route path="/dashboard/services-content" element={        <ProtectedRoute>          <div className="dashboard-container">            <Sidebar />            <div className="main-content">              <Header />              <ServicesSectionEditor />            </div>          </div>        </ProtectedRoute>      } />


              <Route path="/dashboard/about-us" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <AboutUsSectionEditor />
                    </div>
                  </div>
                </ProtectedRoute>
              } />

              <Route path="/dashboard/contact-us" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <ContactUsSectionEditor />
                    </div>
                  </div>
                </ProtectedRoute>
              } />


              <Route path="/dashboard/header-settings" element={        <ProtectedRoute>          <div className="dashboard-container">            <Sidebar />            <div className="main-content">              <Header />              <HeaderEditor />            </div>          </div>        </ProtectedRoute>      } />

              <Route path="/dashboard/products" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <ProductManagement />
                    </div>
                  </div>
                </ProtectedRoute>
              } />

              {/* New route for AllProductsView */}
              <Route path="/dashboard/all-products" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <AllProductsView />
                    </div>
                  </div>
                </ProtectedRoute>
              } />

              <Route path="/dashboard/dealership-logos" element={        <ProtectedRoute>          <div className="dashboard-container">            <Sidebar />            <div className="main-content">              <Header />              <DealershipLogosEditor />            </div>          </div>        </ProtectedRoute>      } />

              
              <Route path="/dashboard/update-password" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <UpdatePasswordPage />
                    </div>
                  </div>
                </ProtectedRoute>
              } />

              <Route path="/dashboard/manage-users" element={
                <ProtectedRoute>
                  <div className="dashboard-container">
                    <Sidebar />
                    <div className="main-content">
                      <Header />
                      <ManageUsersPage />
                    </div>
                  </div>
                </ProtectedRoute>
              } />
              
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;